import { useMemo } from "react";

import { AXNUIFormHelpTextContainer } from "@iddataweb/idw-common-ui/containers";
import { AXNUIContent, AXNUILayout, AXNUITheme } from "@iddataweb/idw-common-ui/types";
import { ThemingGenericContentSlotTypes } from "@iddataweb/idw-common-ui/enums";
import { getAXNUILayoutHelpTextParameters } from "@iddataweb/idw-common-ui/utils";

type AXNUIThemingPostFormHelpTextContainerProps = {
    axnuiContent: AXNUIContent;
    axnuiLayout: AXNUILayout;
    axnuiTheme: AXNUITheme;
};

export const AXNUIThemingPostFormHelpTextContainer = (props: AXNUIThemingPostFormHelpTextContainerProps) => {
    const { axnuiContent, axnuiLayout, axnuiTheme } = props;

    const helpTextParameters = useMemo(()=> {
         return getAXNUILayoutHelpTextParameters(axnuiContent, axnuiLayout, ThemingGenericContentSlotTypes.POST_FORM_HELP_TEXT);
    }, [axnuiLayout.helpText.postFormHelpText, axnuiContent]);

    return (
        <AXNUIFormHelpTextContainer
            parameters={helpTextParameters}
            id={ThemingGenericContentSlotTypes.POST_FORM_HELP_TEXT}
            content={axnuiContent}
            explicitConsentChecked={false}
            isSubmitting={false}
            setExplicitConsentChecked={() => {}}
            textColor={axnuiTheme.general.mainTextColor}
            fontFamily={axnuiTheme.general.font}
            buttonTextColor={axnuiTheme.general.mainButtonTextColor}
            buttonBackgroundColor={axnuiTheme.general.mainButtonBackgroundColor}
            linksColor={axnuiTheme.general.linksColor}
        />
    );
};